// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7HIkV","inline":"Footer_inline__ZnQ5h","item":"Footer_item__v9eMR","list":"Footer_list__b7TUF"};